import {useEffect, useRef, useState} from 'react'
import {
  SDrawerOrModal,
  SLowcodeList,
  STableActions,
  SActionBtn
} from 'shj-components';
import { getPriceExportRecord, doExport } from '@/services/product.ts'
import { config } from './config'

export default function ExportModal({ open = false, setOpen = (status: boolean) => ({}) }) {
  const listRef = useRef<any>(null)
  const [loading, setLoading] = useState(false)
  const timeIntervalRef = useRef<any>(null);
  
  useEffect(() => {
    onSearch()
    timeIntervalRef.current = setInterval(() => {
      onSearch()
    }, 30000)
  }, [])

  const onClose = () => {
    clearInterval(timeIntervalRef.current);
    setOpen(false)
  }

  const onSearch = async () => {
    const res: any = await getPriceExportRecord({})
    if (Array.isArray(res)) {
      listRef?.current?.updateDataSource(res, res?.length || 0);
    }
  }

  const exportData = async (id: string) => {
    const res = await doExport(id);
    if (res) {
      onSearch()
    }
  }

  const handleDownload = (record: any) => {
    const x = new XMLHttpRequest();
    x.open('GET', record.downloadUrl, true);
    x.responseType = 'blob';
    x.onload = () => {
      const url = window.URL.createObjectURL(x.response);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${record.batchKey}-${record.batchIndex}.xlsx`;
      a.click();
    }
    x.send();
  }

  const extensions = {
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {
              record.status === 'WAIT' || record.status === 'ERROR' ? (
                <SActionBtn onClick={() => exportData(record?.id)}>
                  点击生成
                </SActionBtn>
              ) : null
            }
            {
              record.downloadUrl ? (
                <SActionBtn onClick={() => handleDownload(record)}>
                  下载
                </SActionBtn>
              ) : null
            }
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SDrawerOrModal
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        antdProps={{
          footer: null
        }}
        loading={loading}
        width={800}
        title={'分批导出记录'}
      >
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </SDrawerOrModal>
    </div>
  )
}